import {
  MrSearchConfig,
  MrSearchFacetsConfig,
  MrSearchLayoutInput,
} from '@net7/boilerplate-muruca';

const facets = {
  sections: [
    {
      id: 'section-query',
      inputs: [
        {
          id: 'query',
          type: 'text',
          queryParam: true,
          delay: 500,
          schema: {
            valueType: 'string',
          },
          data: {
            id: 'query',
            placeholder: 'search#placeholder_query',
            icon: 'n7-icon-search',
            inputPayload: 'search-input',
            enterPayload: 'search-enter',
            iconPayload: 'search-icon',
          },
        },
      ],
    },
    {
      id: 'section-primary',
      inputs: [
        {
          id: 'primary',
          type: 'checkbox',
          queryParam: true,
          delay: 500,
          schema: {
            valueType: 'string',
          },
          data: {
            // legend: 'Legend test',
            checkboxes: [
              {
                id: 'id_checkbox-1',
                label: 'Traduzione primaria',
                payload: 'primary_translation',
                checked: false,
              }
            ]
          }
        }
      ]
    },
    {
      id: 'section-translation_type',
      header: {
        id: 'header-translation_type',
        data: {
          text: 'search#header_translation_type',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'translation_type',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-works',
      header: {
        id: 'header-works',
        data: {
          text: 'search#header_works',
          additionalText: null,
        },
      },
      inputs: [
        {
          type: 'text',
          id: 'query-works',
          target: 'works',
          delay: 500,
          schema: {
            valueType: 'string',
          },
          data: {
            id: 'query-works',
            placeholder: 'search#placeholder_works',
            icon: 'n7-icon-search',
            inputPayload: 'search-input',
            enterPayload: 'search-enter',
            iconPayload: 'search-icon',
          },
        },
        {
          id: 'works',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    // {
    //   id: 'section-translation_parts',
    //   header: {
    //     id: 'header-translation_parts',
    //     data: {
    //       text: 'search#header_translation_parts',
    //       additionalText: null,
    //       iconRight: 'n7-icon-angle-down',
    //     },
    //   },
    //   inputs: [
    //     {
    //       id: 'translation_parts',
    //       type: 'link',
    //       limit: 50,
    //       queryParam: true,
    //       schema: {
    //         valueType: 'string',
    //         multiple: true,
    //       },
    //       data: {
    //         links: [],
    //       },
    //     },
    //   ],
    // },
    {
      id: 'section-author_work',
      header: {
        id: 'header-author_work',
        data: {
          text: 'search#header_author_work',
          additionalText: null,
        },
      },
      inputs: [
        {
          type: 'text',
          id: 'query-author_work',
          target: 'author_work',
          delay: 500,
          schema: {
            valueType: 'string',
          },
          data: {
            id: 'query-author_work',
            placeholder: 'search#placeholder_author_work',
            icon: 'n7-icon-search',
            inputPayload: 'search-input',
            enterPayload: 'search-enter',
            iconPayload: 'search-icon',
          },
        },
        {
          id: 'author_work',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-print_type',
      header: {
        id: 'header-print_type',
        data: {
          text: 'search#header_print_type',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'print_type',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-translator',
      header: {
        id: 'header-translator',
        data: {
          text: 'search#header_translator',
          additionalText: null,
        },
      },
      inputs: [
        {
          type: 'text',
          id: 'query-translator',
          target: 'translator',
          delay: 500,
          schema: {
            valueType: 'string',
          },
          data: {
            id: 'query-translator',
            placeholder: 'search#placeholder_translator',
            icon: 'n7-icon-search',
            inputPayload: 'search-input',
            enterPayload: 'search-enter',
            iconPayload: 'search-icon',
          },
        },
        {
          id: 'translator',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-print_place',
      header: {
        id: 'header-print_place',
        data: {
          text: 'search#header_print_place',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'print_place',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-publisher',
      header: {
        id: 'header-publisher',
        data: {
          text: 'search#header_publisher',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'publisher',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-century',
      header: {
        id: 'header-century',
        data: {
          text: 'search#header_century',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'century',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-source',
      header: {
        id: 'header-source',
        data: {
          text: 'search#header_source',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'source',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-metric',
      header: {
        id: 'header-metric',
        data: {
          text: 'search#header_metric',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'metric',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-place',
      header: {
        id: 'header-place',
        data: {
          text: 'search#header_place',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'place',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
    {
      id: 'section-pressmark',
      header: {
        id: 'header-pressmark',
        data: {
          text: 'search#header_pressmark',
          additionalText: null,
        },
      },
      inputs: [
        {
          id: 'pressmark',
          type: 'link',
          limit: 50,
          queryParam: true,
          schema: {
            valueType: 'string',
            multiple: true,
          },
          data: {
            links: [],
          },
        },
      ],
    },
  ],
  classes: 'facets-wrapper',
} as MrSearchFacetsConfig;

const layoutInputs = ['page', 'limit', 'sort'].map((id) => ({
  id,
  queryParam: true,
  schema: {
    valueType: id === 'sort' ? 'string' : 'number',
  },
})) as MrSearchLayoutInput[];

const request = {
  results: {
    id: 'search',
    delay: 500,
  },
  facets: {
    id: 'facets',
  },
  provider: 'rest',
  delay: 500,
};

export default { request, facets, layoutInputs } as MrSearchConfig;
